function DownloadIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M13 3v9.586l3.293-3.293 1.414 1.414L12 16.414l-5.707-5.707 1.414-1.414L11 12.586V3h2zM4 20h16v-2H4v2z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}

export default DownloadIcon;
